var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "lg", title: "Reject hours" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative h-60" }, [
              _c("div", { staticClass: "w-full space-y-1" }, [
                _c("p", { staticClass: "font-bold text-base" }, [
                  _vm._v(" Provide a rejection reason : "),
                ]),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reason,
                      expression: "reason",
                    },
                  ],
                  staticClass:
                    "focus:outline-none border border-gray-300 rounded-lg w-full h-32 resize-none p-3 text-gray-500 placeholder-gray-300",
                  attrs: { placeholder: "Reason" },
                  domProps: { value: _vm.reason },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.reason = $event.target.value
                    },
                  },
                }),
              ]),
              _c(
                "div",
                {
                  staticClass: "w-full flex justify-end mt-5 gap-4",
                  attrs: { id: "decline-buttons" },
                },
                [
                  _c("UiButton", {
                    attrs: {
                      disabled: false,
                      variant: "outline",
                      buttonText: "Cancel",
                      processing: _vm.processing,
                    },
                    on: { click: _vm.closeModal },
                  }),
                  _c("UiButton", {
                    attrs: {
                      disabled: _vm.reason === "",
                      variant: "black",
                      buttonText: "Decline Request",
                      processing: _vm.processing,
                    },
                    on: { click: _vm.declineTime },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }